import { jsxs as m, jsx as i } from "react/jsx-runtime";
import u, { useRef as h, useEffect as d } from "react";
import { MDCNotchedOutlineFoundation as a } from "@material/notched-outline";
import { useFoundation as f, createComponent as N, Tag as C } from "@rmwc/base";
const O = (n) => {
  const { foundation: o, ...l } = f({
    props: n,
    elements: {
      rootEl: !0,
      notchedEl: !0
    },
    foundation: ({ rootEl: e, notchedEl: t }) => new a({
      addClass: (c) => e.addClass(c),
      removeClass: (c) => e.removeClass(c),
      setNotchWidthProperty: (c) => t.setStyle("width", c + "px"),
      removeNotchWidthProperty: () => t.setStyle("width", "")
    })
  }), { rootEl: s } = l, r = h();
  return d(() => {
    n.notch ? o.notch(n.notch) : o.closeNotch();
  }, [n.notch, o]), d(() => {
    var t;
    r.current = ((t = s.ref) == null ? void 0 : t.querySelector(".mdc-floating-label")) || void 0;
    const e = r.current;
    e ? (e.style.transitionDuration = "0s", s.addClass(a.cssClasses.OUTLINE_UPGRADED), requestAnimationFrame(() => {
      e && (e.style.transitionDuration = "");
    })) : s.addClass(a.cssClasses.NO_LABEL);
  }, [s]), { foundation: o, ...l };
}, L = N(
  function(o, l) {
    const { children: s, ...r } = o, { rootEl: e, notchedEl: t } = O(o);
    return /* @__PURE__ */ m(
      C,
      {
        ...r,
        element: e,
        className: "mdc-notched-outline",
        ref: l,
        children: [
          /* @__PURE__ */ i(g, {}),
          /* @__PURE__ */ i(
            "div",
            {
              ...t.props({
                className: "mdc-notched-outline__notch"
              }),
              ref: t.reactRef,
              children: s
            }
          ),
          /* @__PURE__ */ i(E, {})
        ]
      }
    );
  }
), g = u.memo(function() {
  return /* @__PURE__ */ i("div", { className: "mdc-notched-outline__leading" });
}), E = u.memo(function() {
  return /* @__PURE__ */ i("div", { className: "mdc-notched-outline__trailing" });
});
export {
  L as NotchedOutline
};
